(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(25300);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/hooks/useToast.ts + 7 modules
var useToast = __webpack_require__(29969);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./src/shared/constants/routes.ts + 1 modules
var routes = __webpack_require__(8216);
// EXTERNAL MODULE: ./src/modules/auth/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(1404);
// EXTERNAL MODULE: ./src/shared/components/Form/FormGroup/index.tsx + 1 modules
var FormGroup = __webpack_require__(24293);
// EXTERNAL MODULE: ./src/shared/components/Form/ControlledInput/index.tsx
var ControlledInput = __webpack_require__(23058);
// EXTERNAL MODULE: ./src/shared/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(67399);
// EXTERNAL MODULE: ./src/shared/components/AuthLink/index.tsx + 1 modules
var AuthLink = __webpack_require__(22025);
// EXTERNAL MODULE: ./src/shared/components/AuthHeader/index.tsx + 2 modules
var AuthHeader = __webpack_require__(25914);
;// CONCATENATED MODULE: ./src/modules/auth/pages/SignIn/index.tsx












const schemaValidation = es/* object */.Ry().shape({
    email: es/* string */.Z_().email("O formato do e-mail est\xe1 incorreto").required("E-mail \xe9 obrigat\xf3rio"),
    password: es/* string */.Z_().required("Senha \xe9 obrigat\xf3rio")
});
const SignIn = ()=>{
    const { control , formState: { isSubmitting , errors  } , handleSubmit  } = (0,dist_index_esm/* useForm */.cI)({
        defaultValues: {
            email: "",
            password: ""
        },
        resolver: (0,yup/* yupResolver */.X)(schemaValidation)
    });
    const { signIn  } = (0,useAuth/* useAuth */.a)();
    const handleSignIn = handleSubmit(signIn);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthHeader/* AuthHeader */.k, {
                title: "Seja bem vindo",
                subtitle: "Fa\xe7a o seu login para entrar no portal"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSignIn,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledInput/* ControlledInput */.B, {
                            control: control,
                            icon: index_esm/* FiUser */.fzv,
                            name: "email",
                            placeholder: "Digite o seu e-mail",
                            error: errors.email,
                            autoComplete: "email",
                            size: "lg"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledInput/* ControlledInput */.B, {
                            control: control,
                            icon: index_esm/* FiLock */.UIZ,
                            name: "password",
                            type: "password",
                            placeholder: "Digite a sua senha",
                            error: errors.password,
                            autoComplete: "current-password",
                            size: "lg"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        type: "submit",
                        backgroundColor: "secondary",
                        textColor: "onSecondary",
                        mt: "md",
                        size: "lg",
                        isLoading: isSubmitting,
                        children: "Entrar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthLink/* AuthLink */.g, {
                        href: routes/* routes.AUTH.PASSWORD_RECOVERY */._.AUTH.PASSWORD_RECOVERY,
                        icon: index_esm/* FiHelpCircle */.bax,
                        title: "Esqueci minha senha"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/index.tsx





const SignInPage = (param)=>{
    let { toastData  } = param;
    const toast = (0,useToast/* useToast */.p)();
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const parsedToastData = JSON.parse(toastData);
        if (Object.values(parsedToastData).length > 0) {
            toast.show(parsedToastData);
            router.push({
                pathname: router.pathname
            }, undefined, {
                shallow: true
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        toastData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn, {});
};
var __N_SSP = true;
/* harmony default export */ var pages = (SignInPage);


/***/ }),

/***/ 22025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ AuthLink; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(54335);
;// CONCATENATED MODULE: ./src/shared/components/AuthLink/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  color: ",
        ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  width: 100%;\n\n  transition: opacity 0.3s ease-in;\n\n  > svg {\n    width: 13px;\n    height: 13px;\n    stroke-width: 3px;\n  }\n\n  > span {\n    font-size: 13px;\n    line-height: 13px;\n    font-weight: 600;\n  }\n\n  &:hover {\n    opacity: 0.65;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-166047e7-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.spacing.md;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.gray[600];
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xs;
});

;// CONCATENATED MODULE: ./src/shared/components/AuthLink/index.tsx



const AuthLink = (param)=>{
    let { href , icon: Icon , title  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: title
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7536,2343,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);